/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import ViewImageComponent from '../../../../components/ViewImageComponent';
import ProfileTitle from '../ProfileTitle';
import './AccountVerification.scss';

interface IAccountVerificationDoc{
  payload:any;
  fetchUser?:any;
  index?: number;
}
const AccountVerificationDoc = ({ payload, fetchUser, index }:IAccountVerificationDoc) => {
  const { documents } = payload;
  const { customerId } = useParams<{ customerId: string }>();

  const [isVerificationDetailHidden, setIsVerificationDetailHidden] = useState(false);

  return (
    <div className="verification-doc-cover-page">
      <ProfileTitle
        name="Account Verification"
        index={index}
        onClick={() => setIsVerificationDetailHidden(!isVerificationDetailHidden)}
      />
      {isVerificationDetailHidden && (
      <div className="column">
        {
          documents?.map((list, i) => (
            <div key={i} className="col-xl-4">
              {/* {list?.documentType} */}
              <div style={{ marginBottom: '32px' }}>
                <ViewImageComponent
                  pageName="document"
                  name={list?.documentType}
                  docType={list?.docKey}
                  payload={list}
                  merchantId={customerId}
                  imageSize={list?.meta?.file_size}
                  imageType={list?.meta?.contentType}
                  fileExt={list?.file_ext}
                  fetchUser={fetchUser}
                  uploadDocumentType="admin_user_upload"
                  hideActions={payload.isDeleted}
                  canUpdatePermission="can-upload-admin-user-document"
                  canAcceptPermission="can-approve-document"
                  canRejectPermission="can-reject-document"
                  showStatusIcon
                />
              </div>
            </div>
          ))
        }
      </div>
      )}
    </div>
  );
};
export default AccountVerificationDoc;
